mutation DeleteLanguages($ids: [ID!]!) {
  deleteLanguages(ids: $ids) {
    id
    deletedAt
  }
}
